<template>
    <div>
        <table-tool-bar>
            <template slot="left"></template>
            <Button
                    :class="preCls + 'button-margin'"
                    :disabled="loading"
                    type="default"
                    @click="onClickEduce"
            >导出Excel
            </Button>
        </table-tool-bar>
        <Table ref="mt" :columns="columns" :data="page.list" :loading="loading" :height="mtHeight">
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickAction(row, '')"
                >详情
                </Button>
                <Button
                        v-if="$can('report') && showButton(row, '1')"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickAction(row, '1')"
                >报备确认
                </Button>
                <Button
                        v-if="$can('visit') && showButton(row, '2')"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickAction(row, '2')"
                >到访确认
                </Button>
                <Button
                        v-if="$can('reception')"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickReception(row)"
                >客户接待
                </Button>
                <Button
                        v-if="$can('finish') && (showButton(row, '2') || 
                        showButton(row, '4') || showButton(row, '5'))"
                        type="default"
                        size="small"
                        style="margin-right: 5px;"
                        @click="rowClickAction(row, '3')"
                >成交确认
                </Button>
                <Button
                        v-if="$can('windup') && showButton(row, '6')"
                        type="default"
                        size="small"
                        @click="rowClickAction(row, '4')"
                >结佣确认
                </Button>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
                :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"
        ></table-pager>
        <!-- 弹出层 -->
        <smart-modal v-model="modal.showRecommend"
                     :title="titleByActionStatus(actionStatus)"
                     :width="800"
                     :height="actionStatus == 1? 610 : (actionStatus == 2? 420 : (actionStatus == 3? 500 : (actionStatus == 4 || customerStatus == 4? 640 : 610)))"
                     :maskcolsable="false"
                     :buttons.sync="buttons"
                     @close-by-confirm="search">
            <form-recommend v-if="modal.showRecommend"
                            :customerStatus="customerStatus"
                            :actionStatus="actionStatus"
                            :execStatus="execStatus"
                            :id="curId">
            </form-recommend>
        </smart-modal>
        <smart-modal
                v-model="modal.showReception"
                title="客户接待"
                :width="800"
                :height="650"
                :maskcolsable="false"
                :buttons.sync="buttons"
                @close-by-confirm="search">
            <form-reception
                    v-if="modal.showReception"
                    :id="curId"
            ></form-reception>
        </smart-modal>
    </div>
</template>
<script>
    import {mapCell, pipeCell} from '_c/grid/renderCell'
    import FormRecommend from './form-recommend'
    import FormReception from './form-reception'

    import {customerReportList, deleterecommend} from '@/api/customer-recommend'
    import Dict from '_u/dict'
    import dayjs from 'dayjs'

    const PAGE_SIZE = 20
    const clog = console.log;

    const fetchData = function () {
        return Promise.all([
            Dict.get(['customer_status']),
            customerReportList({
                pageNo: 1,
                pageSize: PAGE_SIZE
            })
        ])
    }

    export default {
        name: 'ListRecommend',

        components: {
            FormRecommend,
            FormReception
        },
        props: {
            propFilter: Object,
            customerStatus: String
        },
        data() {
            return {
                mtHeight: 360,
                loading: false,
                filter: {
                    pageNo: 1,
                    pageSize: PAGE_SIZE
                },
                page: {
                    total: 0,
                    list: []
                },
                dict: {
                    customerStatus: Dict.NULL,
                    execStatus: Dict.NULL
                },
                modal: {
                    showRecommend: false,
                    showReception: false,
                },
                curId: '',
                execStatus: "",
                actionStatus: '',
                buttons: [{type: 'default', text: '关闭', name: 'cancel'}]
            }
        },

        computed: {
            columns() {
                let cols = [
                    {
                        type: 'index',
                        title: '序号',
                        align: 'center',
                        width: 60
                    },
                    {
                        key: 'customerName',
                        title: '姓名',
                        align: 'left',
                        minWidth: 60
                    },
                    {
                        key: 'projName',
                        title: '楼盘',
                        align: 'left',
                        minWidth: 120
                    },
                    {
                        key: 'phone',
                        title: '手机号',
                        align: 'left',
                        minWidth: 120
                    },
                    {
                        key: 'execStatus',
                        title: '状态',
                        align: 'center',
                        minWidth: 100,
                        render: mapCell(this.dict.execStatus.val())
                    },
                    {
                        key: 'brokerName',
                        title: '经纪人',
                        align: 'left',
                        minWidth: 60
                    },
                    {
                        key: 'action',
                        title: '操作',
                        align: 'center',
                        width: 300,
                        slot: 'action'
                    }
                ]
                if (this.customerStatus == '1') {
                    // 报备
                    cols.splice(-1, 0, {
                        key: 'reportTime',
                        title: '报备时间',
                        align: 'left',
                        minWidth: 150,
                        render: pipeCell('ymdL')
                    })
                } else if (this.customerStatus == '2') {
                    // 到访
                    cols.splice(-1, 0, {
                        key: 'visitTime',
                        title: '到访时间',
                        align: 'left',
                        minWidth: 150,
                        render: pipeCell('ymdL')
                    })
                } else if (this.customerStatus == '3') {
                    // 成交
                    cols.splice(
                        -1,
                        0,
                        {
                            key: 'dealTime',
                            title: '成交时间',
                            align: 'left',
                            minWidth: 150,
                            render: pipeCell('ymdL')
                        },
                        {
                            key: 'dealAmount',
                            title: '成交金额(元)',
                            align: 'right',
                            minWidth: 120,
                            render: pipeCell('currency')
                        }
                    )
                } else if (this.customerStatus == '4') {
                    // 结佣
                    cols.splice(
                        -1,
                        0,
                        {
                            key: 'liquidationTime',
                            title: '结佣时间',
                            align: 'left',
                            minWidth: 150,
                            render: pipeCell('ymdL')
                        },
                        {
                            key: 'liquidationAmount',
                            title: '结佣金额(元)',
                            align: 'right',
                            minWidth: 120,
                            render: pipeCell('currency')
                        }
                    )
                }
                return cols
            }
        },

        created() {
            this.fetch()
        },

        mounted() {
            this.afterContainerResize((el, detector) => {
                this.mtHeight =
                    detector.windowHeight -
                    this.$refs.mt.$el.getBoundingClientRect().top -
                    80
            })
        },
        watch: {
            propFilter: {
                handler: function (el) {
                    this.fetch()
                },
                deep: true
            }
        },
        methods: {
            fetch() {
                this.loading = true
                let body = Object.assign(
                    {customerStatus: this.customerStatus},
                    this.filter,
                    this.propFilter
                )
                Promise.all([
                    Dict.get(['customer_status', 'exec_status']),
                    customerReportList(body)
                ]).then(args => {
                    var [dictGroup, page] = args

                    Object.keys(this.dict).forEach(name => {
                        this.dict[name] = dictGroup[name]
                    })

                    page.data.page.list.forEach(o => {
                        o.cellClassName = {"execStatus": `exec-status-color${o.execStatus}`};
                    });

                    this.setPageData(page.data)
                }).finally(() => {
                    this.loading = false
                })
            },

            search() {
                this.page.pageNo = 1
                this.fetch()
            },

            setPageData(data) {
                this.page.list = data.page.list
                this.page.total = parseInt(data.page.totalCount)
            },

            onClickEduce(e) {
                let filter = Object.assign(
                    {customerStatus: this.customerStatus},
                    this.filter,
                    this.propFilter
                )
                Object.assign(filter, {
                    pageNo: 1,
                    pageSize: 9999
                })
                let headers = JSON.parse(
                    JSON.stringify(this.columns.filter(el => el.key != 'action'))
                )
                headers.forEach(el => {
                    el.width = 300
                })
                customerReportList(filter).then(res => {
                    let list = res.data.page.list

                    list.forEach(el => {
                        el.execStatus = el.execStatus ? this.dict.execStatus.val(el.execStatus) : ''
                        el.reportTime = el.reportTime ? dayjs(el.reportTime).format('YYYY-MM-DD HH:mm:ss') : ''
                        el.visitTime = el.visitTime ? dayjs(el.visitTime).format('YYYY-MM-DD HH:mm:ss') : ''
                        el.dealTime = el.dealTime ? dayjs(el.dealTime).format('YYYY-MM-DD HH:mm:ss') : ''
                        el.liquidationTime = el.liquidationTime ? dayjs(el.liquidationTime).format('YYYY-MM-DD HH:mm:ss') : ''
                    })

                    var filename = ''
                    if (this.customerStatus == '1') {
                        filename = '报备客户'
                    } else if (this.customerStatus == '2') {
                        filename = '到访客户'
                    } else if (this.customerStatus == '3') {
                        filename = '成交客户'
                    } else if (this.customerStatus == '4') {
                        filename = '结佣客户'
                    }

                    this.$refs.mt.exportToExcel({
                        filename: filename + `_${dayjs().format('YYYYMMDDHHmmss')}`,
                        rows: list,
                        headers
                    })
                })
            },

            rowClickAction(row, actionStatus) {
                this.actionStatus = actionStatus;
                this.execStatus = row.execStatus;
                this.curId = row.id;
                this.modal.showRecommend = true
            },

            showButton(row, execStatus) {
                return row.execStatus == execStatus;
            },

            rowClickReception(row) {
                this.curId = row.id;
                this.modal.showReception = true
            },
            //弹框的标题文字
            titleByActionStatus(actionStatus) {
                //详情按钮弹出的标题
                const xqMapping = {
                    "1": "报备详情",
                    2: "报备详情",
                    3: "报备详情",
                    4: "到访详情",
                    5: "到访详情",
                    6: "成交详情",
                    7: "结佣详情",
                };
                //确认按钮弹出的标题
                const qrMapping = {
                    1: "报备确认",
                    2: "到访确认",
                    3: "成交确认",
                    4: "结佣确认"
                };
                if (actionStatus === "") {
                    return xqMapping[this.execStatus];
                } else {
                    return qrMapping[actionStatus];
                }
                // return actionStatus == 1 ? '确认报备' : (actionStatus == 2 ? '确认到访' : (actionStatus == 3 ? '确认成交' : (actionStatus == 4 ? '确认结佣' : '客户详情')));
            },
        }
    }
</script>
<style lang="less" scoped>
</style>
<style>
    .exec-status-color1 {
        color: #ff9900;
    }

    .exec-status-color2 {
        color: #00CCFF;
    }

    .exec-status-color3 {
        color: #808080;
    }

    .exec-status-color4 {
        color: #33CCAE;
    }

    .exec-status-color5 {
        color: #22DD22;
    }

    .exec-status-color6 {
        color: #0000FF;
    }

    .exec-status-color7 {
        color: #8F33CC;
    }
</style>